import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faVideo } from '@fortawesome/pro-light-svg-icons'

import { BlankState, Button } from '@domain-group/suit-theme'

import useLoginAsUser from '@hooks/useLoginAsUser'
import { generateUrls } from '@hooks/useTrainingCourse'

import BlankStateImageUrl from '../../assets/no-comparables.png'

const CampaignComparableBlankState = () => {
  const { oldTrainingDashboardIndex } = generateUrls()

  const { callbacks: { loginAsUser } } = useLoginAsUser({ redirect: oldTrainingDashboardIndex })

  return (
    <BlankState boxProps={{ marginBottom: 'large' }} imageUrl={BlankStateImageUrl}>
      {/*
       // @ts-expect-error TS2339 */}
      <BlankState.Title>No Comparables</BlankState.Title>

      {/*
       // @ts-expect-error TS2339 */}
      <BlankState.Paragraph>
        This campaign has no comparable properties selected. You can search your own agency&apos;s listings, market
        sales and listings or create your own custom comparables if they&apos;re missing from the data supplier.
        {/*
       // @ts-expect-error TS2339 */}
      </BlankState.Paragraph>

      {/*
       // @ts-expect-error TS2339 */}
      <BlankState.Actions>
        <Button
          buttonStyle="secondaryUtility"
          icon={<FontAwesomeIcon icon={faVideo} />}
          onClick={() => loginAsUser()}
          size="medium"
          width="auto"
        >
          Watch Video
        </Button>
        {/*
       // @ts-expect-error TS2339 */}
      </BlankState.Actions>
    </BlankState>
  )
}

export default CampaignComparableBlankState
